module.exports = require("./../internal/prefix") + "invalidated";
